import { render, staticRenderFns } from "./EventsOverview.vue?vue&type=template&id=20852d13"
import script from "./EventsOverview.js?vue&type=script&lang=js&external"
export * from "./EventsOverview.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports